
import { ContactButton } from "@/components/ui/contact-button";

export const ReachOut = () => {
  return (
    <section className="p-12 rounded-[32px] mt-16 bg-white px-0">
      <h2 className="text-[62px] font-medium mb-8">Get in Touch</h2>
      <div className="space-y-6 text-[22px] font-inter mb-12">
        <p></p>
        <p>
          Email me at hiba@rarefolks.com with:
        </p>
        <ul className="space-y-4">
          <li>• Event name and type</li>
          <li>• Desired date and location</li>
          <li>• Expected audience size and background</li>
          <li>• Preferred topic or focus area</li>
        </ul>
      </div>
      <ContactButton email="hiba@rarefolks.com" />
    </section>
  );
};
